// Import 3rd-party dependencies
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

// Import project-specific dependencies
import { ApiService } from '@app/services/api.service';
import { environment } from '@app/environments/environment';
import { Observable } from 'rxjs';

export interface IProfileLinks {
  id?: string;
  title: string;
  link: string;
  country: string[];
}

@Injectable({
  providedIn: 'root'
})
export class ProfileLinksService extends ApiService {
  constructor(httpClient: HttpClient) {
    super(httpClient);
  }

  private ADMIN_API_URL = environment.DEPS.ADMIN_API.URL;

  profileLinks$ = this.getProfileLinks();

  getProfileLinks(): Observable<IProfileLinks[]> {
    return this.get<IProfileLinks[]>(`${this.ADMIN_API_URL}/cms/profilelinks`);
  }

  putProfileLink(profileLinks: IProfileLinks): Observable<any> {
    return this.put(`${this.ADMIN_API_URL}/cms/profilelinks`, profileLinks);
  }

  deleteProfileLink(profileLinks: IProfileLinks): Observable<any> {
    return this.delete(`${this.ADMIN_API_URL}/cms/profilelinks/delete?title=${profileLinks.title}`);
  }
}
